<div class="nav-bar">
  <nav class="top-nav-bar">
    <div class="nav-home-container">
      <a routerLink="/" routerLinkActive="active">
        <img class="nav-home-image" src="../assets/images/abcis-white.png" alt="ABCis Logo" />
      </a>
    </div>
    <div class="top-controller">
      <div class="channel-selector">
        <button mat-button [matMenuTriggerFor]="channelMenu" class="channel-button">
          <span class="channel-text">{{ getSelectedChannelName() }}</span>
          <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #channelMenu="matMenu" class="channel-menu" panelClass="channel-menu-panel">
          <button
            mat-menu-item
            *ngFor="let channel of channels"
            (click)="selectChannel(channel.id)"
          >
            {{ channel.name }}
          </button>
        </mat-menu>
      </div>
      <button mat-button [matMenuTriggerFor]="menu" class="profile-button">
        <mat-icon>person</mat-icon>
        <span>Profile</span>
      </button>
      <mat-menu #menu="matMenu" class="profile-menu" panelClass="profile-menu-panel">
        <button mat-menu-item (click)="logOut()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Log Out</span>
        </button>
      </mat-menu>
    </div>
  </nav>
</div>
<div class="body-container">
  <!-- Rest of your navigation content -->
  <div class="navigation">
    <div class="nav-main">
      <div
        (mouseenter)="mouseEnterNav()"
        (mouseleave)="mouseLeaveNav()"
        [style.width.px]="navWidth"
        class="nav-menu"
        [ngClass]="dragging ? 'dragging' : ''"
      >
        <div class="nav-menu-container">
          <div class="nav-menu-top-container">
            <div *ngFor="let category of this.navCategories" class="nav-link-category">
              <span class="link-category">{{ category.name }}</span>
              <div *ngFor="let primaryLinks of category.link">
                <mat-accordion>
                  <!-- Navlink when its by itself-->
                  <div *ngIf="primaryLinks.links === undefined">
                    <a
                      ngClass="nav-link"
                      [routerLink]="primaryLinks.path"
                      routerLinkActive="nav-active-link"
                    >
                      <div ngClass="nav-link-container">
                        <mat-icon>{{ primaryLinks.icon }}</mat-icon>
                        <span>{{ primaryLinks.name }}</span>
                      </div>
                    </a>
                  </div>
                  <!-- Navlink when has children-->
                  <div *ngIf="primaryLinks.links !== undefined">
                    <mat-expansion-panel class="mat-elevation-z0" ngClass="nav-expansion-panel">
                      <mat-expansion-panel-header
                        [expandedHeight]="'35px'"
                        [collapsedHeight]="'35px'"
                        ngClass="nav-link-heading"
                      >
                        <mat-panel-title>
                          <mat-icon>{{ primaryLinks.icon }}</mat-icon
                          ><span>{{ primaryLinks.name }}</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div *ngFor="let secondaryLinks of primaryLinks.links">
                        <a
                          ngClass="nav-link"
                          [routerLink]="secondaryLinks.path"
                          routerLinkActive="nav-active-link"
                        >
                          <div ngClass="nav-link-container">
                            <span *ngIf="secondaryLinks.count">
                              <mat-icon
                                *ngIf="secondaryLinks.icon"
                                [matBadge]="secondaryLinks.count.pendingCount"
                                matBadgePosition="above after"
                                matBadgeColor="warn"
                                [matBadgeOverlap]="true"
                                matBadgeSize="medium"
                                [matBadgeHidden]="
                                  !secondaryLinks.count.pendingCount ||
                                  secondaryLinks.count.pendingCount === 0
                                "
                                aria-hidden="false"
                                [attr.aria-label]="
                                  'Notification count: ' + secondaryLinks.count.pendingCount
                                "
                              >
                                {{ secondaryLinks.icon }}
                              </mat-icon>
                              {{ secondaryLinks.name }}
                            </span>
                            <span *ngIf="!secondaryLinks.count">
                              <mat-icon *ngIf="secondaryLinks.icon" matSuffix>{{
                                secondaryLinks.icon
                              }}</mat-icon>
                              {{ secondaryLinks.name }}
                            </span>
                          </div>
                        </a>
                      </div>
                    </mat-expansion-panel>
                  </div>
                </mat-accordion>
              </div>
            </div>
          </div>
          <div class="nav-bottom-version">v{{ currentApplicationVersion }}</div>
        </div>
      </div>
    </div>
    <div class="nav-control">
      <div class="nav-control-gradient"></div>
      <div
        (mouseenter)="mouseEnterNav()"
        (mouseleave)="mouseLeaveNav()"
        (mousedown)="onMouseDown($event)"
        (window:mouseup)="onMouseUp($event)"
        (window:mousemove)="onMouseMove($event)"
        (click)="ToggleNav()"
        class="nav-resize"
        [style.cursor]="navIsToggled ? 'default' : 'ew-resize'"
      >
        <div [ngClass]="navIsToggled ? null : 'nav-resize-box'"></div>
      </div>
      <button
        (mouseenter)="mouseEnterNav()"
        (mouseleave)="mouseLeaveNav()"
        (click)="ToggleNav()"
        class="nav-toggle"
        [style.opacity]="navIsToggled ? 1 : null"
      >
        <mat-icon>{{ svgUrl }}</mat-icon>
      </button>
    </div>
  </div>
  <div
    [style.padding-left.px]="contentWidth"
    class="main-container"
    [ngClass]="dragging ? 'dragging' : ''"
  >
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
